export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_21.88267e02.jpg";